var exports = {
  "kL": "xa9f3555f--22c3f0--container",
  "Qs": "xa9f3555f--22c3f0--content",
  "YC": "xa9f3555f--22c3f0--titles",
};

module.exports = exports;
